import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    contentWrapper: {
        padding: theme.spacing(2),
        backgroundColor: '#F8FAFF',
        marginTop: theme.spacing(0.5),
    },
    sectionTitle: {
        fontSize: theme.typography.pxToRem(16),
        marginBottom: theme.spacing(1),
        color: '#3C4B68',
    },
    text: {
        color: '#606060',
    },
    tagsSection: {
        width: '100%',
    },
    tagsWrapper: {
        display: 'flex',
        overflowY: 'auto',
        // Hide scrollbar for Chrome, Safari, Firefox and edge
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
}));
